import o from "./chunk381.js";
const p = (r, t) => o.AES.encrypt(r, t).toString();
export {
  p as encrypt
};
